import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Logo } from "../../components/site/Seo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center container-px hero-glow">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo className="h-9" /></Link>
        <div className="card-surface p-7">
          <h1 className="font-heading text-xl font-bold mb-4">Choose a new password</h1>
          <form onSubmit={submit} className="space-y-4">
            <Input type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-ink border-line h-11" data-testid="reset-password" />
            <Button disabled={busy || !token} className="btn-ember rounded-full w-full h-11" data-testid="reset-submit">{busy ? "Updating…" : "Update password"}</Button>
          </form>
          <div className="text-center mt-5"><Link to="/login" className="text-xs text-content-muted hover:text-ember">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
